import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  AccountService,
  AlertService,
  CRMCampaignService,
  CampaignProductService,
  CampaignService,
  CampaignTrackingService,
  CancelReasonCategoryService,
  FunnelStepService,
  MerchantService,
  ReportsConfigService,
  SingleStepReportService,
  StorageService,
  UserService,
} from "../_services";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgxSmartModalService } from "ngx-smart-modal";
import { ReportsAbstractV2Component } from "./reports-abstract-v2.component";
import { MultiOptions } from "../custom-multi-select/multi-select";
import { SingleStepFields, SingleStepFilters } from "./utils/constants";
import { cloneDeep } from "lodash";
import { ReportDimensions, ReportTypes } from "./models/reports";

@Component({
  moduleId: module.id.toString(),
  selector: "single-step-report",
  templateUrl: "./templates/mini-report.component.html",
  styleUrls: ["./styles/reports-v2.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SingleStepReportComponent extends ReportsAbstractV2Component implements OnInit {
  reportTitle = "Single Step Report";
  fields: MultiOptions = cloneDeep(SingleStepFields);
  filters: MultiOptions = cloneDeep(SingleStepFilters);
  reportType = ReportTypes.SINGLE_STEP;
  dropdownsLoading: boolean = false;
  showSavesOnly: boolean = true;
  enableSavesOnlyFilter: boolean = true;
  showSummaryRow: boolean = true;
  fieldLabels = {
    [ReportDimensions.PathName]: "Single Step",
    [ReportDimensions.StepImpressions]: "Step",
  };

  predefinedFields = [];
  commonReportsFields = [];
  summaryFields = [];

  selectedDimensions = [
    {
      model: ReportDimensions.PathName,
      label: "Single Step",
      selected: true,
      disabled: false,
    },
    {
      model: ReportDimensions.StepImpressions,
      label: "Step",
      selected: true,
      disabled: false,
    },
    {
      model: ReportDimensions.Impressions,
      label: "Impressions",
      selected: true,
      disabled: false,
    },
    {
      model: ReportDimensions.HoldSaves,
      label: "Hold Saves",
      selected: true,
      disabled: false,
    },
    {
      model: ReportDimensions.SubscriptionSaves,
      label: "Subscription Saves",
      selected: true,
      disabled: false,
    },
    {
      model: ReportDimensions.RmaSaves,
      label: "RMA Saves",
      selected: true,
      disabled: false,
    },
  ];

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected alertService: AlertService,
    public reportsService: SingleStepReportService,
    protected campaignService: CampaignService,
    protected reportsConfigService: ReportsConfigService,
    protected trackingSourceService: CampaignTrackingService,
    protected userService: UserService,
    protected accountService: AccountService,
    protected campaignProductService: CampaignProductService,
    protected crmCampaignService: CRMCampaignService,
    protected storageService: StorageService,
    protected stepService: FunnelStepService,
    protected merchantService: MerchantService,
    protected modalService: NgxSmartModalService,
    protected cancelReasonCategoryService: CancelReasonCategoryService
  ) {
    super(
      router,
      location,
      route,
      alertService,
      reportsService,
      campaignService,
      reportsConfigService,
      trackingSourceService,
      userService,
      accountService,
      campaignProductService,
      crmCampaignService,
      storageService,
      stepService,
      merchantService,
      modalService,
      cancelReasonCategoryService
    );

    this.updatePreSelectedDimensions(
      this.selectedDimensions.map((dimension) => dimension.model)
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getSummary() {
    this.isSummaryLoading = false;
  }

  getReport(fetchSummary: boolean = false) {
    super.getReport(false);
  }

  onShowSavesOnlyChange() {
    this.isConfigChanged = true;
  }

  getQueryForReport() {
    let query = super.getQueryForReport();
    if (this.showSavesOnly) {
      query.fields = [...query.fields, "show_saves_only"];
    }
    return query;
  }
}
